<template>
  <v-app class="app">
    <AppBar />
    <v-main>
      <v-container>
        <MainScreenMonitorRamais />
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Footer from '@/componentes/Footer'

import MainScreenMonitorRamais from '../components/MainScreenMonitorRamais'
import AppBar from '../components/AppBar'

export default {
  name: 'MonitorHome',
  components: { Footer, AppBar, MainScreenMonitorRamais },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
